import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from 'app/core/base.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class StatusPartOrderService {
	private static readonly BASE_URL: string = BaseService.HOST + '/statusPartOrders';

	constructor(private http: HttpClient) {}

	getAll(params: HttpParams): Observable<any> {
		return this.http.get(StatusPartOrderService.BASE_URL, {params: params})
			.pipe(catchError(BaseService.handleError));
	}
}
